import React, { Component } from 'react';
import {
  List,
  Flex,
  Toast
} from 'antd-mobile';
import LinkText from './components/link'
import Location from './components/location'
import DatePickerSE from './components/date-picker-view'
import Table from '../../components/Table';
import df from 'dateformat'
import send from '../../utils/send';
import {FARM_ORG, ORG_CODE} from '../../cache';
import EmptyReport from '../../components/EmptyReport'

let day = new Date().getTime() - 7 * 24 * 60 * 60 * 1000;
export default class Report11 extends Component {
  constructor (props) {
    super(props);
    this.state = {
      showLoc: false,
      showStart: false,
      showEnd: false,
      parLocation: 'ALL',
      startDate: new Date(day),
      endDate: new Date(),
      tableData1: [],
      tableData2: [],
      column1: [
        {
          id: 'company_name_loc',
          title: '序号',
          align: 'left',
          width: 40,
          fixed: true,
          render (data, index) {
            return index + 1
          }
        },
        {
          id: 'transaction_date',
          title: '日期',
          fixed: true
        },
        {
          id: 'swine_track',
          title: '猪只代码',
          width: 160
        },
        {
          id: 'parity',
          title: '胎次',
          width: 80
        },
        {
          id: 'oubound_name_loc',
          width: 80,
          title: '淘汰类型'
        },
        {
          id: 'reason_name_loc',
          title: '淘汰原因'
        },
        {
          id: 'last_activity_type',
          title: '淘汰状态'
        },
        {
          id: 'breeder',
          title: '品种'
        },
        {
          id: 'trn_in_activity_date',
          title: '入场时间'
        },
        {
          id: 'transfer_in_farm_org_loc',
          title: '所在农场',
          width: 150
        },
        {
          id: 'atbirth_farm_org_loc',
          title: '舍',
          width: 150
        }
      ],
      column2: [
        {
          id: 'location',
          title: '舍'
        },
        {
          id: 'qtyAllLoc',
          title: '淘汰数量'
        },
        {
          id: 'avgParityLoc',
          title: '平均胎次'
        }
      ]
    }
  }

  onCancel = () => {
    this.setState({
      showLoc: false,
      showStart: false,
      showEnd: false
    })
  };
  doSearch = () => {
    Toast.loading('请稍等', 0);
    const {startDate, endDate} = this.state;
    let start = startDate;
    let end = endDate;
    if (startDate > endDate) {
      start = endDate;
      end = startDate;
      this.setState({startDate: start, endDate: end})
    }
    send({
      url: '/api/forward/ifarm/report11',
      method: 'POST',
      data: {
        farmOrg: FARM_ORG,
        orgCode: ORG_CODE,
        parLocation: this.state.parLocation,
        startDate: df(start, 'yyyy-mm-dd'),
        endDate: df(end, 'yyyy-mm-dd')
      }
    }).then(res => {
      Toast.hide();
      if (res.status !== 200) {
        return
      }
      let data = res.data;
      this.setState({
        tableData2: [
          {
            location: '后备舍',
            qtyAllLoc: data.qtyAllLoc6 || 0,
            avgParityLoc: data.avgParityLoc6 || 0
          },
          {
            location: '配种舍',
            qtyAllLoc: data.qtyAllLoc1 || 0,
            avgParityLoc: data.avgParityLoc1 || 0
          },
          {
            location: '汇总',
            qtyAllLoc: data.qtyAllLoc || 0,
            avgParityLoc: data.avgParity || 0
          }
        ],
        tableData1: data.rows
      })
    })
  };
  componentDidMount() {
    this.doSearch()
  }

  render() {
    const {showLoc, showStart, showEnd,parLocation,startDate, endDate} = this.state;
  return (
    <div className="oneH">
      <List  className={(showLoc || showStart || showEnd)? 'single-multi-menu-active text-list-item': 'text-list-item'}>
        <Flex wrap={'nowrap'}>
          <List.Item className={'single-multi-top-nav-bar'}
              onClick={() => {
            this.setState({
              showLoc: !showLoc,
              showStart: false,
              showEnd: false
            })
          }}
              style={{width: '50px',paddingLeft: 10}}
          >
            <LinkText show={showLoc}>{'全部'}</LinkText>
          </List.Item>
          <List.Item className={'single-multi-top-nav-bar'}
              onClick={() => {
            this.setState({
              showStart: !showStart,
              showLoc: false,
              showEnd: false
            })
          }}
              style={{width: '120px',paddingLeft: '10px'}}
          >
            <LinkText show={showStart}>配种开始日期</LinkText>
          </List.Item>
          <List.Item className={'single-multi-top-nav-bar'}
              onClick={() => {
            this.setState({
              showEnd: !showEnd,
              showLoc: false,
              showStart: false
            })
          }}
              style={{width: 'calc(100vw - 190px)'}}
          >
            <LinkText show={showEnd}>配种截止日期</LinkText>
          </List.Item>
        </Flex>
      </List>
      <div style={{position: 'absolute',zIndex: 180,width: '100%'}}>
        {
          showLoc ? <Location
              onCancel={this.onCancel}
              onConfirm={(value) => {
            this.setState({
              showLoc: false,
              parLocation: value
            }, () => {
              this.doSearch()
            })
            }}
              value={parLocation}
                    />: null
        }
        {
          showStart ?<DatePickerSE onCancel={this.onCancel}
              onConfirm={(value) => {
                                     this.setState({
                                       showStart: false,
                                       startDate: value
                                     }, () => {
                                       this.doSearch()
                                     })
                                   }}
              value={startDate}
                     /> : null
        }
        {
          showEnd ?<DatePickerSE onCancel={this.onCancel}
              onConfirm={(value) => {
                                     this.setState({
                                       showEnd: false,
                                       endDate: value
                                     }, () => {
                                       this.doSearch()
                                     })
                                   }}
              value={endDate}
                   /> : null
        }
      </div>
      <List.Item
          className={'span-4'}
          extra={`${df(startDate, 'yyyy-mm-dd')} ~ ${df(endDate, 'yyyy-mm-dd')}`}
      >
        时间范围
      </List.Item>
      {showLoc || showStart || showEnd ? <div className="menu-mask"/> : null}
      {
        this.state.tableData1.length > 0 && <Table
            columns={this.state.column1}
            data={this.state.tableData1}
            stripe
                                            />
      }
      {this.state.tableData1.length > 0 ?<Table
          columns={this.state.column2}
          data={this.state.tableData2}
                                         />: <EmptyReport height={150} />}

    </div>
  )
 }
}
